module.exports = __webpack_public_path__ + "img/ss.e553f37c.png";